<template>
    <v-row>
        <v-col :class="attributeInputCols">
            <v-autocomplete
                @change="onAttributesChanged"
                :value="relation.attributeId"
                :label="$t('attribute')"
                :items="attributes"
                :rules="[
                    () => this.isUnique || this.$t('notUniqueValue'),
                    rules.required
                ]"
                item-text="name"
                item-value="id"
                hide-no-data
                cache-items
                clearable
                color="teal lighten-2"
                item-color="teal lighten-2"
            ></v-autocomplete>
        </v-col>
        <v-col v-if="!isSingle">
            <v-btn
                text
                @click="setRemoveRelation"
            ><v-icon>close</v-icon></v-btn>
        </v-col>
        <v-col class="col-12">
            <v-autocomplete
                @change="onCategoriesChanged"
                :value="relation.categoryIDs"
                :label="$t('categories')"
                :items="categoryItems"
                :rules="[rules.notEmpty]"
                item-text="localName"
                item-value="id"
                hide-no-data
                clearable
                multiple
                color="teal lighten-2"
                item-color="teal lighten-2"
            ></v-autocomplete>
        </v-col>
    </v-row>
</template>

<script>
import { MixinTextFieldValidators } from '../../../mixins'
export default {
    name: "AttributeCategoryItem",
    mixins: [ MixinTextFieldValidators ],
    props: [ 'relation', 'index', 'attributesCategories', 'isUnique', 'isSingle' ],

    computed: {
        attributeInputCols() {
            return this.isSingle ? 'col-12' : 'col-11'
        },
        categoryItems() {
            const attribute = this.attributesCategories.find(item => {
                return item.id === this.relation.attributeId
            });
            return attribute ? attribute.categories : [];
        },
        attributes() {
            return this.attributesCategories.map(item => {
                return {
                    id: item.id,
                    name: item.localName
                }
            })
        },
    },
    methods: {
        setRemoveRelation() {
            this.$emit('remove', this.index);
        },
        onAttributesChanged(value) {
            this.$emit('set-relation', {
                relation: {
                    attributeId: value,
                    categoryIDs: []
                },
                idx: this.index
            })

        },
        onCategoriesChanged(value) {
            this.$emit('set-relation', {
                relation: {
                    attributeId: this.relation.attributeId,
                    categoryIDs: value
                },
                idx: this.index
            })
        }
    },
}
</script>

<style scoped>

</style>
